import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import "../../Style/scss/pages/dashboard.scss";
import { Header } from "./Header";
import { SideBar } from "./SideBar";
import { ChatSideList } from "../Chat/ChatSideList";
import { useDispatch, useSelector } from "react-redux";
import { ErrorModel } from "../../Model/ErrorModel";
import { setErrorMessage } from "../../Redux/Slice/Common/SelectedTabSlice";

const Layout = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [openSidebar, setOpenSidebar] = useState(false);
  const [errorModel, setErrorModel] = useState(false);
  const errorMessage = useSelector(
    (state) => state.hasUnsavedChanges.errorMessage
  );
  const userData = JSON.parse(localStorage.getItem("userData"));
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (!userData) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (errorMessage && errorMessage != "") {
      setError(errorMessage);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
        dispatch(setErrorMessage(""));
        localStorage.removeItem("userData");
      }, 2000);
    }
  }, [errorMessage]);

  if (!userData) {
    return <Navigate to="/" replace={true} />;
  }

  return (
    <>
      {errorModel ? <ErrorModel message={error} /> : ""}
      {userData ? (
        <section
          className={`layoutContainer ${openSidebar ? "sidebar-hidden" : ""}`}
        >
          <SideBar setOpenSidebar={setOpenSidebar} />
          {location.pathname.includes("chat") ? (
            <>
              <div
                className={`layoutGrid layoutGrid--chats ${
                  location.pathname == "/chat" ? "" : "layoutGrid--show"
                }`}
              >
                <div className="layoutGrid__col">
                  <ChatSideList />
                </div>
                <div className="layoutGrid__col">
                  <div className="page">
                    <Header
                      openSidebar={openSidebar}
                      onClickHamburgerIcon={() => setOpenSidebar((p) => !p)}
                    />
                    <Outlet />
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="layoutGrid">
              <div
                className={
                  location.pathname.includes("add-assistant-builder")
                    ? "page page__full page--conversationChats"
                    : (location.pathname.includes("assistant") &&
                        !location.pathname.includes(
                          "assistant/form-submission"
                        ) &&
                        !location.pathname.includes("view-assistants")) ||
                      location.pathname.includes("addPayment") ||
                      location.pathname.includes("Reports") ||
                      location.pathname.includes("dashboard") ||
                      location.pathname.includes("reports") ||
                      ((location.pathname.includes("call") ||
                        location.pathname.includes("email")) &&
                        !location.pathname.includes("call-email-history")) ||
                      location.pathname.includes("group-call") ||
                      location.pathname.includes("group-call") ||
                      ((location.pathname.includes("add-subscription-plan") ||
                        location.pathname.includes("edit-subscription-plan") ||
                        location.pathname.includes("subscription-payment")) &&
                        !location.pathname.includes("subscription-plan")) ||
                      location.pathname.includes("phoneNumbers") || 
                      location.pathname.includes("topup-payment")
                    ? "page"
                    : location.pathname.includes("users") ||
                      location.pathname.includes("customerUser") ||
                      location.pathname.includes("contacts") ||
                      location.pathname.includes("call-email-history") ||
                      location.pathname.includes("customers") ||
                      location.pathname.includes("plans") ||
                      location.pathname == "/plan-types" ||
                      location.pathname.includes("customerbilling") ||
                      location.pathname.includes("view-assistants") ||
                      location.pathname.includes("group-members") ||
                      location.pathname.includes("transaction-history") ||
                      location.pathname.includes("assistant/form-submission")
                    ? "page page__fullBody"
                    : "page page__full"
                }
              >
                <Header
                  openSidebar={openSidebar}
                  onClickHamburgerIcon={() => setOpenSidebar((prev) => !prev)}
                />
                {/* <div className="page__body"> */}
                <Outlet />
              </div>
            </div>
          )}
        </section>
      ) : (
        navigate("/")
      )}
    </>
  );
};

export default Layout;
